import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './credentials/shared/not-found/not-found.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'credentials',loadChildren: () => import('./credentials/credentials.module').then(m => m.CredentialsModule), pathMatch: 'prefix' },
  { path: 'dashboard',loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule), pathMatch: 'prefix' },
  { path: '404', component: NotFoundComponent, pathMatch: 'full'},
  { path: '**', redirectTo: '404'}    
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }